<template>
  <PageMain class="bg-w mt-20 send-page   ">
    <!-- <div class="fs-20 fs-b f-c-b mb-20 pt-20 pl-20 pr-20">在线预约下单</div> -->
    <a-tabs type="card" default-active-key="1" class="search-tab pt-20">
      <a-tab-pane key="1" :tab="'单个寄件'">
        <LeftForm :order-type="ot" />
      </a-tab-pane>
      <a-tab-pane key="2" tab="批量寄件" force-render>
        <RightForm :order-type="ot" />
      </a-tab-pane>
    </a-tabs>
    <a-radio-group v-model="ot" class="send-type ">
      <a-radio v-if="$store.state.user.hasCompany" :value="1">
        因公寄件
      </a-radio>
      <a-radio :value="2">
        个人寄件
      </a-radio>
    </a-radio-group>
  </PageMain>
</template>
<script>

/**
 * 如何使用vue
 * 这里做最基本的用法演示，详细请看vue的官网
 * https://cn.vuejs.org/v2/guide/
 */
import LeftForm from './leftForm'
import RightForm from './rightForm'

export default {
  name: 'Send',
  components: {
    LeftForm,
    RightForm
  },
  data() {
    // data函数返回的对象是具有双向绑定的数据，更新data里面的数据，可以触发ui的变化
    return {
      count: 0,
      ot: 1
    }
  },
  created() {
    if (!this.$store.state.user.hasCompany) {
      this.ot = 2
    }
  },
  methods: {
    getCount(count) {
      this.count = count
    }
  }
}
</script>

<style lang="scss" >
.search-tab{
  .ant-tabs-nav-scroll{
    padding: 0 20px;
  }
}
  .send-page{
    position: relative;
    .send-type{
      position: absolute;
      top: 30px;
      z-index: 1;
      right: 20px;
  }
  }

</style>
